import { Component, Vue } from 'vue-property-decorator';
import WithRender from './AgentGrowthReport.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';

@WithRender
@Component({
  components: {
    Loading
  }
})
export default class AgentGrowthReport extends Vue {
  isLoading = false;

  month1 = new Date().getMonth() - 1 || 12;
  year1 = this.month1 === 12 ? new Date().getFullYear() - 1 : new Date().getFullYear();
  month2 = new Date().getMonth() || 12;
  year2 = this.month2 === 12 ? new Date().getFullYear() - 1 : new Date().getFullYear();
  month3 = new Date().getMonth() + 1;
  year3 = new Date().getFullYear();
  userId = '';

  perPage = 100;
  currentPage = 1;
  selectedPage = 1;
  totalRecords = 0;

  items = [];
  fields = [
    { key: "fullName",            label: "Name",              sortable: true },
    { key: "userEmail",           label: "Username",          sortable: true },
    { key: "month1Transactions",  label: "M1 Txns",          sortable: true, tdClass: 'table-primary' },
    { key: "month1Amount",        label: "M1 Amount",        sortable: true },
  
    { key: "month2Transactions",  label: "M2 Txns",          sortable: true, tdClass: 'table-primary' },
    { key: "month2Amount",        label: "M2 Amount",        sortable: true },

    { key: "month3Transactions",  label: "M3 Txns",          sortable: true, tdClass: 'table-primary' },
    { key: "month3Amount",        label: "M3 Amount",        sortable: true },
    { key: "transactionGrowth",   label: "Txn Growth",       sortable: true },
    { key: "amountGrowth",        label: "Amount Growth",    sortable: true },
    { key: "growthPercentage",    label: "Growth %",         sortable: true },
  ];

  monthOptions = [
    { value: 1, text: 'January' }, { value: 2, text: 'February' }, { value: 3, text: 'March' },
    { value: 4, text: 'April' }, { value: 5, text: 'May' }, { value: 6, text: 'June' },
    { value: 7, text: 'July' }, { value: 8, text: 'August' }, { value: 9, text: 'September' },
    { value: 10, text: 'October' }, { value: 11, text: 'November' }, { value: 12, text: 'December' },
  ];

  mounted() {
    this.userId = (this.$route.query.userId as string) || '';
    this.getReport();
  }

  handlePageClick() {
    if (this.currentPage === this.selectedPage)
      return;
    this.currentPage = this.selectedPage;
    this.getReport();
  }

  getReport(): void {
    this.isLoading = true;
    const userIdParam = this.userId ? `&userId=${this.userId}` : '';
    _axios.get(`${config.gateway}admin/internal/report/AgentMonthlySales/Growth?month1=${this.month1}&year1=${this.year1}&month2=${this.month2}&year2=${this.year2}&month3=${this.month3}&year3=${this.year3}&currentPage=${this.currentPage}&pageSize=${this.perPage}${userIdParam}`)
      .then(response => {
        this.items = response.data.objectList;
        this.totalRecords = response.data.totalRowCount;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        this.isLoading = false;
      });
  }

  rowClass(item: any) {
    if (item && (item.transactionGrowth < 0 || item.amountGrowth < 0)) {
      return 'table-warning';
    }
    return '';
  }
}
